import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import ConsentBasicInfoForm from "./ConsentBasicInfoForm";
import { validateConsentDetails } from "./consentSimpleModel";

const EMPTY = {
  name: "",
  type: "",
  typeLabel: "",
  speciality: [],
  allSpecialities: false,
};

const NewConsentDialog = ({
  open,
  onClose,
  onCreate,
  meta,
  specialityOptions = [],
  busy,
}) => {
  const [value, setValue] = useState(EMPTY);
  const [errors, setErrors] = useState({});

  const close = () => {
    setValue(EMPTY);
    setErrors({});
    onClose();
  };

  const submit = () => {
    const found = validateConsentDetails(value);
    setErrors(found);
    if (Object.keys(found).length) return;

    onCreate(value);
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>Add New Consent</DialogTitle>
      <DialogContent dividers>
        <ConsentBasicInfoForm
          value={value}
          errors={errors}
          meta={meta}
          specialityOptions={specialityOptions}
          onChange={setValue}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} disabled={busy}>
          Cancel
        </Button>
        <Button variant="contained" onClick={submit} disabled={busy}>
          Create &amp; open builder
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewConsentDialog;
